import { ReduxAction } from './helper';

export const toggleActive = new ReduxAction(
  'APPLET_ACTIVE_TOGGLE',
  urlPath => urlPath
);
